import React from 'react';
import Toast from './Toast';
import type { ToastItem, ToastPosition } from './toast.types';
import './Toast.css';

interface ToastContainerProps {
  toasts: ToastItem[];
  onDismiss: (id: string) => void;
}

// Toutes les positions gerees ; on ne rend un viewport que pour celles qui ont des toasts.
const POSITIONS: ToastPosition[] = [
  'top-right',
  'top-left',
  'top-center',
  'bottom-right',
  'bottom-left',
  'bottom-center',
];

/**
 * Rend une pile ancree par position. Chaque toast declare sa position (defaut top-right),
 * on regroupe donc les toasts par coin et on rend un viewport par groupe non vide.
 * `column-reverse` : le plus recent s'affiche en haut de sa pile.
 */
const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onDismiss }) => {
  if (!toasts.length) {
    return null;
  }

  return (
    <>
      {POSITIONS.map((pos) => {
        const list = toasts.filter((t) => t.position === pos);
        if (!list.length) {
          return null;
        }
        const [vertical, horizontal] = pos.split('-');
        return (
          <div
            key={pos}
            className={`toast-viewport toast-viewport--${vertical} toast-viewport--${horizontal}`}
            role="region"
            aria-label="Notifications"
            aria-live="polite"
          >
            {list.map((t) => (
              <Toast key={t.id} toast={t} onDismiss={onDismiss} />
            ))}
          </div>
        );
      })}
    </>
  );
};

export default ToastContainer;
